"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkippedTask = void 0;
const BaseTask_1 = require("./Task/BaseTask");
class SkippedTask extends BaseTask_1.BaseTask {
}
exports.SkippedTask = SkippedTask;
